import gql from "graphql-tag";

export const TOGGLE_ADMIN_USER = gql`
  mutation toggleAdminUser($adminUserId: String!, $enable: Boolean!) {
    toggleAdminUser(adminUserId: $adminUserId, enable: $enable)
  }
`;
